import {
  contactEmails,
  footerBrand,
  footerCopyright,
  legalHeading,
  legalLinks,
  streamingSitemap,
} from '@archetelos/ui/footer';

import { Logo } from '@/components/brand/Logo';

// The streaming-surface footer (Spec 30 F1/§1). Same shared footerModel as the
// marketing footer, rendered in the dark video idiom with an oxblood top-rule
// and no theme toggle. Mounted full-width at the bottom of BrowsePage.
//
// Legal pages live on the marketing site, so the shared relative legal paths and
// the external "Editorial" link resolve against the marketing origin. The
// on-app links (Donate, and the /#... section anchors) stay app-relative.
export function VideoFooter() {
  const year = new Date().getFullYear();
  const marketing = import.meta.env.PUBLIC_MARKETING_URL ?? 'https://archetelos.stream';

  return (
    <footer className="bg-video-bg">
      <div className="h-0.5 bg-oxblood-browse" />
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo className="h-8 w-auto" />
            <p className="mt-4 font-serif text-sm italic text-video-text-muted">
              {footerBrand.etymology}
            </p>
            <p className="mt-2 text-sm text-video-text-faint">{footerBrand.tagline}</p>
          </div>

          <div>
            <h2 className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-video-text-faint">
              {streamingSitemap.heading}
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm text-video-text-muted">
              {streamingSitemap.links.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    {...(link.external ? { target: '_blank', rel: 'noreferrer' } : {})}
                    className="inline-flex items-center gap-0.5 transition hover:text-video-text"
                  >
                    {link.label}
                    {link.external && <span className="text-xs">↗</span>}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-video-text-faint">
              {legalHeading}
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm text-video-text-muted">
              {legalLinks.map((link) => (
                <li key={link.href}>
                  <a href={`${marketing}${link.href}`} className="transition hover:text-video-text">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <ul className="mt-5 space-y-2.5 text-sm text-video-text-faint">
              {contactEmails.map((email) => (
                <li key={email}>
                  <a href={`mailto:${email}`} className="transition hover:text-video-text">
                    {email}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-video-line pt-5">
          <p className="text-xs text-video-text-faint">{footerCopyright(year)}</p>
        </div>
      </div>
    </footer>
  );
}
